import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminSoftLaunchWaitlist = lazy(() => import("@/pages/admin/AdminSoftLaunchWaitlist"));

export const Route = createFileRoute("/admin/soft-launch-waitlist")({
  component: AdminSoftLaunchWaitlist,
});
